import * as React from 'react';

import { Spinner } from '@admin/components/spinner';
import { client } from '@admin/libraries/apollo';
import { NoteNotableInput, useNotesQuery } from '@admin/schema';

import { Events } from './events';
import { NotesForm } from './form';
import { List } from './list';

export const Widget: React.FC<NoteNotableInput & { needsRefetch?: boolean }> = ({ id, type, needsRefetch = false }) => {
  const { data, refetch, loading } = useNotesQuery({
    client,
    variables: {
      notable: {
        id,
        type,
      },
    },
  });
  const notes = data && data.notes;

  React.useEffect(() => {
    if (needsRefetch) {
      refetch();
    }
  }, [needsRefetch]);

  return (
    <Events refetch={refetch}>
      <NotesForm id={id} type={type} onSave={refetch} />
      {loading && <Spinner />}
      {notes && <List id={id} type={type} notes={notes} />}
    </Events>
  );
};
